import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/alt-goz-kapagi-ameliyatinda-iz-kalmasi-gercek-mi-korku-mu/page.tsx");
